import React from 'react';
import { Flex, FlexItem } from 'core/layout'
import { Loading } from 'core/icons'
import { Heading, Button } from 'elements'
import { Form as Formsy, File } from 'formsy-react-components';
import TextInput from 'elements/Form/Input/TextInput';
import TextArea from 'elements/Form/Input/TextArea';
import tulkojumi from 'utils/tulkojumi';

import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  StyledContent,
  StyledContentP,
  Form,
  Label,
  Atsauce,
  RecaptchaContainer,
} from './styled';

import config from '../../../config'


class FeedbackForm extends React.PureComponent {
  state = {
    canSubmit: false,
    sending: false,
    success: false,
    error: false,
  };

  componentDidMount() {
    this._preloadReCaptcha();

    this._recaptchaStyle = document.createElement('style');
    this._recaptchaStyle.appendChild(document.createTextNode('') /* webkit hack */ );
    document.head.appendChild(this._recaptchaStyle);
    this._recaptchaStyle.sheet.insertRule(`
      body > div:last-child {
        min-height: 580px;
      }
    `, 0);
  }

  componentWillUnmount() {
    grecaptcha && grecaptcha.reset(this._widgetId);

    if (this._recaptchaTimeout) {
      window.clearTimeout(this._recaptchaTimeout);
      this._recaptchaTimeout = null;
    }

    if (this._recaptchaStyle) {
      document.head.removeChild(this._recaptchaStyle);
      this._recaptchaStyle = null;
    }
  }

  _preloadReCaptcha = () => {
    if (this._recaptchaTimeout) {
      window.clearTimeout(this._recaptchaTimeout);
      this._recaptchaTimeout = null;
    }

    if (window.grecaptcha && window.grecaptcha.render) {
      this._initReCaptcha();
    } else {
      console.log('ReCAPTCHA preloading');
      this._recaptchaTimeout = window.setTimeout(this._preloadReCaptcha, 200);
    }
  }

  _initReCaptcha = () => {
    console.log('ReCAPTCHA initialized');
    this._widgetId = window.grecaptcha && window.grecaptcha.render(this._recaptchaContainer, {
      sitekey: config.google.siteKey,
      callback: this._recaptchaSubmit,
      size: 'invisible',
    });
  }

  _disableButton = () => {
    this.setState(prevState => Object.assign({}, prevState, {
      canSubmit: false,
    }));
  }

  _enableButton = () => {
    this.setState(prevState => Object.assign({}, prevState, {
      canSubmit: true,
    }));
  }

  _recaptcha = (model, resetForm, invalidateForm) => {
    this.model = model
    grecaptcha && grecaptcha.execute(this._widgetId);
  }
  _submit = () => {
    const { mutate } = this.props

    window.gtag && gtag('event', 'feedback-form');

    this.setState(prevState => Object.assign({}, prevState, {
      canSubmit: false,
      sending: true,
      sucesss: false,
      error: false,
    }));

    mutate({
      variables: {
        vards: this.model.vards,
        uzvards: this.model.uzvards,
        epasts: this.model.epasts,
        talrunis: this.model.talrunis,
        zina: this.model.zina,
        file: this.model.file && this.model.file[0] ? this.model.file[0] : null,
        /* ReCAPTCHA verifikācija
           URL: https://www.google.com/recaptcha/api/siteverify
           secret (required): 6Lc_1EAUAAAAAO8mxE5RbKt6A8_P73KmFu7Ji5Wi
           response (required): The value of 'g-recaptcha-response' (token).
           remoteip	The end user's ip address. */
        token: this._latestToken,
      },

      update: (proxy, { data: { sendEmail }, errors }) => {
        if (sendEmail && sendEmail.status === 'ok') {
          const { formsyForm } = this._form;
          formsyForm.reset();
          grecaptcha && grecaptcha.reset(this._widgetId);

          this.model = {}

          this.setState(prevState => Object.assign({}, prevState, {
            canSubmit: false,
            sending: false,
            success: true,
          }));

        } else {
          this.setState(prevState => Object.assign({}, prevState, {
            error: true,
            errorMessage: sendEmail.message,
          }));
        }
      }
    })
  }

  _recaptchaSubmit = (token) => {
    this._latestToken = token;
    this._submit();
  }

  render() {
    const {
      teksti,
    } = this.props;

    if (this.state.error) {
      return (
        <div>
          <StyledContent>
            <Heading level={3}>
              {tulkojumi(teksti, 'notikusi_kluda!')}
            </Heading>
            <StyledContentP width={7 / 8}>
              {tulkojumi(teksti, 'pec_briza_pamegini_velreiz')}
            </StyledContentP>
            {
              this.state.errorMessage && (
                <StyledContentP width={7 / 8}>
                  <small>
                  {this.state.errorMessage}
                </small>
                </StyledContentP>
              )
            }
            <Button
              accent='secondary' type='standard'
              a11yLabel={tulkojumi(teksti, 'labi')}
              label={tulkojumi(teksti, 'labi')}
              style={{ marginTop: '1.5em' }}
              onClick={() => {
                this.setState(prevState => Object.assign({}, prevState, {
                  canSubmit: false,
                  sending: false,
                  success: false,
                  error: false,
                }));
              }}
            />
          </StyledContent>
        </div>
      );
    }

    if (this.state.success) {
      return (
        <div>
          <StyledContent>
            <Heading level={3}>
              {tulkojumi(teksti, 'paldies_zina_sanemta!')}
            </Heading>
            <Button
              accent='secondary' type='standard'
              a11yLabel={tulkojumi(teksti, 'labi')}
              label={tulkojumi(teksti, 'labi')}
              onClick={() => {
                this.setState(prevState => Object.assign({}, prevState, {
                  canSubmit: false,
                  sending: false,
                  success: false,
                  error: false,
                }));
              }}
            />
          </StyledContent>
        </div>
      );
    }

    return (
      <div>
        <StyledContent>
          <Heading level={3}>
            {tulkojumi(teksti, 'sazinas_forma')}
          </Heading>
          <StyledContentP width={7 / 8} dangerouslySetInnerHTML={{__html: tulkojumi(teksti, 'sazinas_forma_apraksts')}} />
        </StyledContent>

        <Form>

          <Formsy
            onValidSubmit={this._recaptcha}
            onValid={this._enableButton}
            onInvalid={this._disableButton}
            ref={c => this._form = c}
          >

            <Flex wrap="true" >
              <FlexItem basis={4 / 8} >
                <Label >
                  <span>
                    {tulkojumi(teksti, 'vards')}*
                  </span>
                </Label>
                <TextInput
                  tabIndex={0}
                  aria-label={tulkojumi(teksti, 'vards')}
                  name="vards"
                  validations="minLength:3"
                  displayError={true}
                  validationError={tulkojumi(teksti, 'kluda')}
                  required
                />
              </FlexItem>

              <FlexItem basis={4 / 8} >
                <Label >
                  <span>
                    {tulkojumi(teksti, 'uzvards')}*
                  </span>
                </Label>

                <TextInput
                  tabIndex={1}
                  aria-label={tulkojumi(teksti, 'uzvards')}
                  name="uzvards"
                  validations="minLength:3"
                  displayError={true}
                  validationError={tulkojumi(teksti, 'kluda')}
                  required
                />
              </FlexItem>

              <FlexItem basis={4 / 8} >
                <Label >
                  <span>
                    {tulkojumi(teksti, 'tavs_e_pasts')}*
                  </span>
                </Label>
                <TextInput
                  tabIndex={2}
                  aria-label={tulkojumi(teksti, 'tavs_e_pasts')}
                  name="epasts"
                  validations="isEmail"
                  displayError={true}
                  validationError={tulkojumi(teksti, 'kluda')}
                  required
                />
              </FlexItem>

              <FlexItem basis={4 / 8} >
                <Label >
                  <span>
                    {tulkojumi(teksti, 'talrunis')}
                  </span>
                </Label>

                <TextInput
                  tabIndex={3}
                  aria-label={tulkojumi(teksti, 'talrunis')}
                  name="talrunis"
                  validations="minLength:7"
                  displayError={true}
                  validationError={tulkojumi(teksti, 'kluda')}
                />
              </FlexItem>

              <FlexItem basis={8 / 8} >
                <Label >
                  <span>
                    {tulkojumi(teksti, 'zina')}*
                  </span>
                </Label>

                <TextArea
                  tabIndex={4}
                  aria-label={tulkojumi(teksti, 'tava_zina')}
                  name="zina"
                  validations="minLength:7"
                  displayError={true}
                  validationError={tulkojumi(teksti, 'kluda')}
                  required
                />
                <Atsauce>
                  *{tulkojumi(teksti, 'obligatie_lauki')}<br /><br />
                  {tulkojumi(teksti, 'jus_varat_pievienot_failu_sados_formatos')}
                </Atsauce>
              </FlexItem>

              <RecaptchaContainer innerRef={c => this._recaptchaContainer = c} />

              <FlexItem basis={4 / 8} >
                <File
                  tabIndex={4}
                  name="file"
                  accept=".jpg,.jpeg,.png"
                />
              </FlexItem>

              <FlexItem basis={4 / 8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  accent='secondary' type='standard' typeAttr='submit'
                  a11yLabel={tulkojumi(teksti, 'nosutit')}
                  disabled={!this.state.canSubmit}
                >
                  {
                    this.state.sending ? <Loading /> : tulkojumi(teksti, 'nosutit')
                  }
                </Button>
              </FlexItem>

            </Flex>
          </Formsy>
        </Form>
      </div>
    );
  }
}

export default graphql(gql`
  mutation( $vards: String!,$uzvards: String!, $epasts: String!, $talrunis: String, $zina: String!, $file: Upload, $token: String!) {

    sendEmail(vards: $vards,uzvards: $uzvards,epasts: $epasts,talrunis: $talrunis,zina: $zina, file: $file, token: $token){
      status,
      message
    }

  }
`)(FeedbackForm)



// WEBPACK FOOTER //
// ./src/modules/FeedbackForm/FeedbackForm.jsx